var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7063 2.01648C13.9324 1.24263 12.4422 1.08238 6.8019 3.39827C2.87094 5.01231 0.60029 5.96811 0.998012 8.42831C1.17266 9.50865 2.28423 11.1673 3.53427 12.501V14.9249C3.53427 15.9481 4.74855 16.4852 5.50564 15.797L6.46153 14.928C7.1384 15.3478 7.78157 15.6418 8.29443 15.7247C10.7546 16.1224 11.7104 13.8518 13.3245 9.92084C15.6404 4.28056 15.4801 2.79033 14.7063 2.01648Z",
    fill: "#0A0C13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7063 2.01648C13.9324 1.24263 12.4422 1.08238 6.8019 3.39827C2.87094 5.01231 0.60029 5.96811 0.998012 8.42831C1.17266 9.50865 2.28423 11.1673 3.53427 12.501V14.9249C3.53427 15.9481 4.74855 16.4852 5.50564 15.797L6.46153 14.928C7.1384 15.3478 7.78157 15.6418 8.29443 15.7247C10.7546 16.1224 11.7104 13.8518 13.3245 9.92084C15.6404 4.28056 15.4801 2.79033 14.7063 2.01648Z",
    stroke: "#84C70D",
    strokeWidth: 1.76786,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8133 2.13327L3.21824 12.1535C2.10161 10.8888 1.15778 9.4166 0.998012 8.42831C0.60029 5.96811 2.87094 5.01231 6.8019 3.39827C12.4422 1.08238 13.9324 1.24263 14.7063 2.01648C14.7434 2.05363 14.7791 2.09243 14.8133 2.13327Z",
    fill: "#84C70D",
    fillOpacity: 0.3,
    stroke: "#84C70D",
    strokeWidth: 1.76786,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.6ba429812455e3ac1d4120e5808209b3.svg";
export { ForwardRef as ReactComponent };